<template>

    <v-menu
            v-model="menuModel"
            ref="dateMenu"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            max-width="450px"
            min-width="290px"
    >
        <template v-slot:activator="{ on }">
            <v-text-field
                    v-model="computedDate"
                    :label="label"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-on="on"
                    :clearable="clearable"
                    :error-messages="errorMessages"
                    @input="dateCleared"
            ></v-text-field>
        </template>

        <v-date-picker
                v-model="pickerDate"
                color="primary"
                :landscape="true"
                @click:date="saveDate"
                :locale="locale"
                :min="min"
                :max="max"
        ></v-date-picker>

    </v-menu>

</template>

<script>

    import {timeDisplay} from '../mixins/timeDisplayMixin';

    export default {

        mixins: [timeDisplay],

        props: {
            value: {
                type: String | null,
                required: true,
            },
            label: {
                type: String,
                required: false,
                default: 'Date'
            },
            min: {
                type: String,
                required: false,
                default: null
            },
            max: {
                type: String,
                required: false,
                default: null
            },
            clearable: {
                type: Boolean,
                required: false,
                default: false,
            },
            locale: {
                type: String,
                required: false,
                default: 'en-US'
            },
            errorMessages: {
                type: Array | null,
                required: false,
                default: null,
            }
        },

        data() {
            return {
                menuModel: false,
            }
        },

        computed: {

            pickerDate: {
                get() {
                    return this.value;
                },
                set(pickerDate) {
                    this.$emit('input', pickerDate);
                }
            },

            computedDate() {
                if (!this.value) {
                    return null;
                }

                if (this.value) {
                    return this.toLocalDate(this.toUTC(this.value));
                }
            },
        },

        methods: {

            saveDate() {
                this.$refs.dateMenu.save(this.pickerDate);
            },

            dateCleared(date) {
                if (!date) {
                    this.$emit('input', null);
                }
            }
        }
    }
</script>
